import { BrokerProvider } from "../../context/BrokerContext";
import PaymentSpeedSelect, { PaymentSpeedInputProps } from "./PaymentSpeedSelect";

export default function PaymentSpeedInput(props: PaymentSpeedInputProps) {
  return (
    <BrokerProvider>
      <PaymentSpeedSelect {...props} />
    </BrokerProvider>
  );
}
